import { configureStore } from '@reduxjs/toolkit';

//apis
import { authApi } from './apis/authApi';
import { userApi } from './apis/userApi';
import { purchaseAPI } from '@/pages/mortgage/apis/purchaseAPI';
import { refinanceAPI } from '@/pages/mortgage/apis/refinanceAPI';
import { onboardAPI } from '@/pages/onboarding/api/onboardAPI';
import { coreAPI } from '@/store/apis/coreApi';
import { lodgeReturnAPI } from '@/pages/tax/apis/lodgeReturnAPI';
import { paymentAPI } from './apis/paymentApi';
//slices
import auth from './slices/auth/authSlice';
import common from './slices/common/commonSlice';
import broker from './slices/broker/brokerSlice';
import { profileAPI } from '@/pages/profile/api/profileAPI';
import { dashboardAPI } from './apis/dashboardApi';
import { dealAPI } from '@/pages/mortgage/apis/dealAPI';
import { referAPI } from '@/pages/profile/api/referAPI';
import propertyAPI from '@/pages/mortgage/apis/propertyAPI';
import { ragAPI } from './apis/ragAPI';
import { externalAuthApi } from '@/pages/external-auth/api/externalAuthApi';
import { blueprintAPI } from '@/pages/blueprint/apis/blueprintApi';
import purchase from './slices/purchase/purchaseSlice';
import refinance from './slices/refinance/refinanceSlice';
import utm from './slices/utm/utmSlice';
export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [purchaseAPI.reducerPath]: purchaseAPI.reducer,
    [refinanceAPI.reducerPath]: refinanceAPI.reducer,
    [onboardAPI.reducerPath]: onboardAPI.reducer,
    [lodgeReturnAPI.reducerPath]: lodgeReturnAPI.reducer,
    [coreAPI.reducerPath]: coreAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [dealAPI.reducerPath]: dealAPI.reducer,
    [paymentAPI.reducerPath]: paymentAPI.reducer,
    [referAPI.reducerPath]: referAPI.reducer,
    [propertyAPI.reducerPath]: propertyAPI.reducer,
    [ragAPI.reducerPath]: ragAPI.reducer,
    [externalAuthApi.reducerPath]: externalAuthApi.reducer,
    [blueprintAPI.reducerPath]: blueprintAPI.reducer,
    auth: auth,
    common: common,
    broker: broker,
    purchase: purchase,
    refinance: refinance,
    utm: utm,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      userApi.middleware,
      purchaseAPI.middleware,
      refinanceAPI.middleware,
      onboardAPI.middleware,
      lodgeReturnAPI.middleware,
      coreAPI.middleware,
      profileAPI.middleware,
      dashboardAPI.middleware,
      dealAPI.middleware,
      paymentAPI.middleware,
      referAPI.middleware,
      propertyAPI.middleware,
      ragAPI.middleware,
      externalAuthApi.middleware,
      blueprintAPI.middleware,
    ),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
